import { api } from "./client";

export async function getMyPools(seasonId) {
  const resp = await api.get(`/games/premier_league/seasons/${seasonId}/pools/mine`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getAllPools(seasonId) {
  const resp = await api.get(`/games/premier_league/seasons/${seasonId}/pools/`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function joinPool(seasonId, poolId) {
  const resp = await api.post(`/games/premier_league/seasons/${seasonId}/pools/${poolId}/join`);
  return resp.data;
}

export async function getPool(seasonId, poolId) {
  const resp = await api.get(`/games/premier_league/seasons/${seasonId}/pools/${poolId}`);
  return resp.data;
}

export async function createPool(seasonId, { name, pool_depth }) {
  const resp = await api.post(`/games/premier_league/seasons/${seasonId}/pools/`, {
    name,
    pool_depth,
  });
  return resp.data;
}

export async function updatePool(seasonId, poolId, body) {
  const resp = await api.patch(`/games/premier_league/seasons/${seasonId}/pools/${poolId}`, body);
  return resp.data;
}

export async function getPlPayouts(seasonId, poolId) {
  const resp = await api.get(`/games/premier_league/seasons/${seasonId}/pools/${poolId}/payouts/`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function savePlPayouts(seasonId, poolId, payouts) {
  const resp = await api.put(`/games/premier_league/seasons/${seasonId}/pools/${poolId}/payouts/`, { payouts });
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function sendPlInvites(seasonId, poolId, emails, message, subject, mode) {
  const resp = await api.post(`/games/premier_league/seasons/${seasonId}/pools/${poolId}/invite`, { emails, message, subject, mode }, { timeout: 120000 });
  return resp.data;
}

export async function sendPlRecapTest(seasonId, poolId) {
  const resp = await api.post(`/games/premier_league/seasons/${seasonId}/pools/${poolId}/recap-test`, null, { timeout: 30000 });
  return resp.data;
}

export async function togglePlMemberPaid(seasonId, poolId, userId, paid) {
  const resp = await api.patch(`/games/premier_league/seasons/${seasonId}/pools/${poolId}/members/${userId}/paid`, { paid });
  return resp.data;
}

export async function togglePlCoAdmin(seasonId, poolId, userId, isCoAdmin) {
  const resp = await api.patch(`/games/premier_league/seasons/${seasonId}/pools/${poolId}/members/${userId}/co-admin`, { is_co_admin: isCoAdmin });
  return resp.data;
}

export async function removePlMember(seasonId, poolId, userId) {
  const resp = await api.delete(`/games/premier_league/seasons/${seasonId}/pools/${poolId}/members/${userId}`);
  return resp.data;
}
